import type { ConstValues } from '@openx/types/helpers';

export const AccountType = {
  GAM: 'GAM',
  ADMOB: 'ADMOB',
} as const;
export type AccountType = ConstValues<typeof AccountType>;

export const Fields = {
  LEGAL_NAME: 'legal_name',
  WEBSITE: 'website',
  EMAILS: 'emails',
  DOMAINS: 'domains',
  BUNDLES: 'bundles',
  CONTRACT_SIGN_IN: 'contract_sign_in',
} as const;
export type Fields = ConstValues<typeof Fields>;

export interface Details {
  [Fields.LEGAL_NAME]: string;
  [Fields.WEBSITE]: string;
  [Fields.EMAILS]: string[];
  [Fields.DOMAINS]: File | null;
  [Fields.BUNDLES]: File | null;
  [Fields.CONTRACT_SIGN_IN]: boolean;
}

export interface PayloadContractField
  extends Pick<Details, typeof Fields.LEGAL_NAME | typeof Fields.WEBSITE | typeof Fields.EMAILS> {
  google_pub_id: string;
  google_network_code?: string;
  google_account_type: AccountType;
}
